import { Switch } from '../../../../components';
import {
    BreathingCircle,
    Exercise,
    LabelBody,
    LabelDisplay2,
    ProgressBar,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { IllustrationPersonThinking, IllustrationThinking } from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export const exerciseData24: ExerciseData = {
    ExerciseView: Module2Exercise4,
    dataKeys: [],
    questions: [],
};

function Module2Exercise4({ exercise, onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Vejrtrækning">
            <ProgressBar current={exercise.CurrentPage} total={4} />
            <Switch
                cases={{
                    1: (
                        <Page1
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 2,
                                });
                            }}
                        />
                    ),
                    2: (
                        <Page2
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 3,
                                });
                            }}
                        />
                    ),
                    3: (
                        <Page3
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.InProgress,
                                    pageNumber: 4,
                                });
                            }}
                        />
                    ),
                    4: (
                        <Page4
                            onContinue={() => {
                                onContinue({
                                    status: ExerciseStatus.Completed,
                                    goToNext: false,
                                });
                            }}
                        />
                    ),
                }}
                value={exercise.CurrentPage}
                default={1}
            />
        </Exercise>
    );
}

type Page1Props = { onContinue: () => void };
function Page1({ onContinue }: Page1Props) {
    return (
        <>
            <LabelDisplay2>
                Aktiver din bremse: Brug din vejrtrækning
            </LabelDisplay2>
            <LabelBody class="mb-30 mt-10">
                Et af vores mest effektive redskaber til at komme ned i kroppen
                og til at aktivere vores krops bremse er vores vejrtrækning.
                Denne øvelse vil guide dig i bevidst og rolig vejrtrækning.
            </LabelBody>
            <IllustrationThinking className="mx-auto mb-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Gå i gang</SecondaryButton>
        </>
    );
}

type Page2Props = { onContinue: () => void };
function Page2({ onContinue }: Page2Props) {
    return (
        <>
            <LabelDisplay2>Sådan gør du</LabelDisplay2>
            <LabelBody class="mt-10">
                Du skal nu trække vejret roligt ind og ud igennem næsen, mens du
                tæller til ti. Træk vejret ind på de ulige tal og pust ud på de
                lige tal. Som en hjælp kan du følge cirklens bevægelser.
            </LabelBody>
            <BreathingCircle class="my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Nu har jeg prøvet det af
            </SecondaryButton>
        </>
    );
}

type Page3Props = { onContinue: () => void };
function Page3({ onContinue }: Page3Props) {
    return (
        <>
            <LabelDisplay2>Prøv det om og om igen</LabelDisplay2>
            <LabelBody class="my-10">
                Vi ved af erfaring at tankerne kan have en tendens til at vandre
                når vi føler os pressede, og besværliggøre at vi kommer ned i
                gear. Det kan ske både ved mindfulness og vejrtrækningsøvelser,
                og det er helt normalt.
            </LabelBody>
            <LabelBody class="mb-30">
                Forsøg nu igen at tælle til ti. Hver gang det bliver svært at
                fastholde tællingen, fordi du opdager, at du sidder fast i en
                tanke, kan du for dig selv sige 'Tænker' og starte forfra med at
                tælle fra et. Det at tælle giver dig et andet fokus end
                tankerne, og ved at sige 'Tænker' bliver du opmærksom på,
                hvornår de flyver. Det er helt normalt at skulle tælle om og om
                igen.
            </LabelBody>
            <IllustrationPersonThinking className="mx-auto mb-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Fortsæt</SecondaryButton>
        </>
    );
}

type Page4Props = { onContinue: () => void };
function Page4({ onContinue }: Page4Props) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Et godt redskab</LabelDisplay2>
            <LabelBody class="mb-30">
                Vi ved af erfaring, at denne øvelse kan være svær at holde af.
                Men den kan være effektfuld, hvis man får erfaring med den. Det
                gode ved den er, at du hverken behøver at ligge ned eller være
                alene. Den kan laves alle steder, også når der er andre
                mennesker til stede – de kan ikke høre, hvad der foregår inde i
                dig.
            </LabelBody>
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Afslut øvelsen
            </SecondaryButton>
        </>
    );
}
